<template>
  <artmisads-modal title="ASIN Details" v-model:open="visible" :footer="null" :width="900" @cancel="closeModal">
    <div class="asin-details">
     
      <div class="asin-header">
        <div class="product-cell">
            <div >
              <LogoImage :logoUrl="modalRecord.imageUrl" :brandName="modalRecord.productTitle" />
            </div>
           
            <div>
              <a-tooltip :title="modalRecord.productTitle" placement="top">
                <div class="product-link">
                  {{ modalRecord.productTitle }}
                </div>
              </a-tooltip>
              <div class="asin-link">
                {{ modalRecord.asin }}
              </div>
            </div>
            <!-- <a href="javascript:void(0)" class="product-link">{{ record.productTitle }}</a> -->
          </div>
      </div>

      <artmisads-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        :scroll="{ x: 650 }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'publisher'">
            <div class="product-cell">
            <div >
              <LogoImage :logoUrl="record.publisherAvatarUrl" :brandName="record.publisherName" />
            </div>
            <div>
              <div >
                  {{ record.publisherName }}
              </div>
            </div>
          </div>
        
          </template>
          <template v-if="column.key === 'clicks'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
                {{ record.attributionClicks||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
                {{ record.associateClicks||0 }}
              </div>
            </div>
          </div>
          </template>
          <template v-if="column.key === 'sales'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.attributionSalesAmount||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.associateSalesAmount||0 }}
              </div>
            </div>
          </div>
          </template>
        </template>
      </artmisads-table>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import LogoImage from "@/components/LogoImage.vue"
import { sellerCpcApi } from "~/server"
import { CURRENCY_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"

const { t } = useI18n()
const user = useUserInfoStore()
const currency = CURRENCY_MAPPER[user.userInfo?.countryCode]?.currency || '$'
const visible = ref(false)

const modalRecord = ref({

})

const columns = computed(() => [
  { title: t("seller.cpcAsinDetailsModal.colPublisher"), dataIndex: "publisher", key: "publisher", width: 200 },
  { title: t("seller.cpcAsinDetailsModal.colClicks"), dataIndex: "clicks", key: "clicks", width: 200 },
  { title: t("seller.cpcAsinDetailsModal.colSales"), dataIndex: "sales", key: "sales", width:200 },
])

const dataSource = ref([])

const openModal = (record) => {
  modalRecord.value = record
  // modalRecord.value = record || {
  //   productName: "",
  //   productImage: "",
  //   clicks: { att: "-", ass: "-" },
  //   sales: { att: "-", ass: "-" },
  // }

  visible.value = true
  getAsinDetails()
}

const getAsinDetails = () => {
  sellerCpcApi.getCpcCampaignsProductsPublishers({ campaignId:  modalRecord.value.campaignId, productId: modalRecord.value.productId,  }).then(res => {
    dataSource.value = res.data

  })
}
const closeModal = () => {
  visible.value = false
}

defineExpose({
  openModal,
  closeModal,
})
</script>

<style scoped lang="less">
.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}


.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
  display: block;
  width: 780px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.asin-link{
  font-family: Sora;
font-weight: 500;
font-size: 12px;
leading-trim: NONE;
line-height: 16px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 0.5);
margin-top: 6px;
}

.asin-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
}

.publisher-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.publisher-name {
  color: #4b5563;
  font-weight: 600;
}

.metric-cell {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .item-row {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;
    min-width: 111px;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
.num {
  margin-left: 8px;
  color: #111827;
}
</style>
